import { render, staticRenderFns } from "./TopToolbarBack.vue?vue&type=template&id=aac33cf4"
import script from "./TopToolbarBack.vue?vue&type=script&lang=ts"
export * from "./TopToolbarBack.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports